module.exports = __webpack_public_path__ + "static/media/dabber.821723b8.jpg";